@if (producer) {
  <div
    class="prod-page-header"
    [ngStyle]="{
      'background-image': newWallpaper
        ? 'linear-gradient(0deg, #101010 0%, rgba(16, 16, 16, 0) 57.65%),' + 'url(' + newWallpaper + ')'
        : 'linear-gradient(0deg, #101010 0%, rgba(16, 16, 16, 0) 57.65%),' +
          'url(' +
          producer?.wallpaperImageUrl +
          ')'
    }"
  >
    <div class="prod-page-header__container">
      <div class="common-container prod-page-header__box">
        <div class="prod-page-header__ava">
          <img
            src="{{ producer?.images.original }}"
            alt="{{ producer?.beatmakerName }} avatar"
            (click)="producer?.beatmakerId === userID && fileAvatarInput.click()"
          />
          <input type="file" (change)="uploadAvatar($event)" style="display: none" #fileAvatarInput />
          @if (producer?.beatmakerId === userID) {
            <div class="hide-icon">
              <div class="edit-avatar-icon btv-icon-edit common-hover" (click)="fileAvatarInput.click()"></div>
              <bmcore-wallpaper-tooltip
                [text]="lg.producerPage.avatarTooltip"
                [infoIconClass]="'ava-info-icon'"
                [contentClass]="'ava-content'"
              >
              </bmcore-wallpaper-tooltip>
            </div>
          }
        </div>
        <div class="prod-page-header__content">
          <div class="prod-page-header__name">
            <div
              [ngClass]="{ 'prod-page-header__icon btv-icon-btn-check': producer?.verified }"
            ></div>
            <p class="common-section-title bm--cut">{{ producer?.beatmakerName }}</p>
          </div>
          <div class="prod-page-header__info">
            <div class="prod-page-header__item">
              <span class="prod-page-header__count common-section-title">
                {{ utilsService.intToString(producer?.totalBeatsCount) }}
              </span>
              <p class="prod-page-header__text">{{ pluralizedTotalBeats }}</p>
            </div>
            <div class="prod-page-header__item">
              <span class="prod-page-header__count common-section-title">
                {{ producer?.totalPlays }}
              </span>
              <p class="prod-page-header__text">{{ pluralizedTotalPlays }}</p>
            </div>
            <div class="prod-page-header__item">
              <span class="prod-page-header__count common-section-title">
                {{ utilsService.intToString(followersCount) }}
              </span>
              <p class="prod-page-header__text">{{ pluralizedTotalFollowers }}</p>
            </div>
          </div>
          <div class="prod-page-header__btn">
            <bmcore-follow-btn
              [beatmakerId]="producer?.beatmakerId"
              [beatmakerName]="producer.beatmakerName"
            ></bmcore-follow-btn>
            @if (appType === 'BMTV' && producer?.beatmakerId !== userID) {
              <bmcore-button
                title="Написать сообщение"
                icon="btv-icon-comment"
                component="LinkAsButton"
                routerPath="/messages#{{ producer.beatmakerId }}"
                styleName="track"
              >
              </bmcore-button>
            }
          </div>
        </div>
        @if (producer?.beatmakerId === userID) {
          <div class="hide-icon">
            <input type="file" (change)="uploadWallpaper($event)" style="display: none" #fileWallpaperInput />
            <div class="edit-wallpaper-icon btv-icon-edit common-hover" (click)="fileWallpaperInput.click()"></div>
            <bmcore-wallpaper-tooltip
              [text]="lg.producerPage.wallpaperTooltip"
              [infoIconClass]="'wallpaper-info-icon'"
              [contentClass]="'wallpaper-content'"
            >
            </bmcore-wallpaper-tooltip>
          </div>
        }
      </div>
    </div>
    @if (!producer) {
      <div class="producer-skeleton"></div>
    }
  </div>
}
